export default __webpack_public_path__ + "static/media/TERMINAL_ICON_14.f009bd58.svg";